module.exports = __webpack_public_path__ + "static/media/contactBcg.945afb99.jpeg";